<template>
  <div class="navbar yld-framework-navbar">
    <div class="left-menu" />
    <div class="right-menu">
      <!-- 多语言 -->
      <el-dropdown v-if="checkFunction.includes('giga_language')" @command="onCommandLanguage">
        <span class="el-dropdown-link language-type">{{ language }}<i
          class="el-icon-arrow-down el-icon--right"
        /></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(langItem, langIndex) of langList" :key="langIndex" :command="langItem.key" :disabled="languageCode === langItem.key">{{ langItem.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 上传记录 -->
      <el-badge class="navbar-download-log" @click.native="goToUploadList">{{ $t('msg.uploadRecordMenu') }}</el-badge>
      <!-- 用户信息 -->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <el-avatar class="user-avatar" shape="circle" :size="40" fit="fill" :src="avatar || defaultHeadUrl" alt="用户头像" />
          <span>{{ userName }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="yld-dropdown-menu">
          <div>
            <el-dropdown-item @click.native="personal">
              <yun-icon name="icon-renwu" />
              <span>{{ $t('msg.personalSettingMenu') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="emptyCache">
              <yun-icon name="icon-shuaxin" />
              <span>{{ $t('msg.emptyCacheMenu') }}</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="checkFunction.includes('system-toggle')" @click.native="gigasales">
              <yun-icon name="icon-shouye" />
              <span>{{ $t('msg.entrySalesPointMenu') }}</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="checkFunction.includes('giga_enter_aisc')" @click.native="geekAisc">
              <yun-icon name="icon-zhanqunguanlixitong" style="font-size: 16px; margin-left: -3px;" />
              <span>{{ $t('msg.enterAisc') }}</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <yun-icon name="icon-dengchu" />
              <span>{{ $t('msg.quitMenu') }}</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BASE_URL } from '@/utils/host'
// import config from '@yld/yun-utils-host'
import { Storage, Cookie } from '@yld/yun-utils-common'
import * as Util from '../../../lang/util'
import * as config from '../../../lang/config'

export default {
  data() {
    return {
      languageCode: 'zh_CN',
      language: Util.getLabelByCode(),
      langList: config?.langList && Object.keys(config.langList).map(key => ({ label: config.langList[key], key })) || []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userInfo',
      'tenantId'
    ]),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    userName() {
      return this.userInfo.realName
    },
    checkFunction() {
      return this.$store.getters.functionKey
    },
    // 默认头像
    defaultHeadUrl() {
      return 'https://yldfiles.geekyum.com/fe/imgs/lht_logo.png'
      // 全球捷运 定制
      // if (this.tenantId && this.tenantId === '578644382409543680') {
      //   return 'https://yldfiles.geekyum.com/fe/imgs/worldex_head.png'
      // } else if (this.tenantId && this.tenantId === '626474597625761792') {
      //   // 冠亚定制
      //   return 'https://yldfiles.geekyum.com/fe/imgs/topasia_head.png'
      // } else if (this.tenantId && this.tenantId === '857678803781554176') {
      //   // 立远定制
      //   return 'https://lyfiless.oss-cn-shanghai.aliyuncs.com/fe/imgs/LY-LOGO.png'
      // } else if (this.tenantId && this.tenantId === '926434557044178944') {
      //   // 信腾
      //   return 'https://geekfiles.oss-cn-shanghai.aliyuncs.com/fe/imgs/xinteng_avatar.png'
      // } else if (this.tenantId && this.tenantId === '584005028001075200') {
      //   // 胜马
      //   return 'https://geekfiles.oss-cn-shanghai.aliyuncs.com/fe/files/sunmarr/shengma_avatar.png'
      // } else {
      //   return 'https://yldfiles.geekyum.com/fe/imgs/def_logo1.png'
      // }
    }
  },
  mounted() {
    this.languageCode = Cookie.getCookie('_xLang_code', null, false)
    Util.toggleLanguage(null, this)
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    onCommandLanguage(command) {
      this.language = Util.getLabelByCode(command)
      Util.toggleLanguage(command, this, () => {
        this.$router.go(0)
      })
    },
    // 上传记录
    goToUploadList() {
      this.$router.push('/uploadList')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
    },
    // 个人中心
    personal() {
      if (this.$appId === '90002') {
        const path = this.$route.path
        if (path !== '/90002/personal') {
          this.$router.push('/90002/personal')
        }
      } else {
        window.open(BASE_URL.WG.HOME_WORK + '/90002/personal', '_blank')
      }
    },
    // 进入销售端
    gigasales() {
      const languageCode = Cookie.getCookie('_xLang_code', null, false)
      this.$store.dispatch('language/getLanguage', { packageName: 'giga', languageCode: languageCode || 'zh_CN' })
      // 胜马特殊跳转
      if (this.tenantId && this.tenantId === '584005028001075200') {
        window.open('https://sales.sunmarr.com', '_blank')
      } else {
        // 生产跳转销售端
        window.open(BASE_URL.WG.GIGASALES_URL, '_blank')
      }
    },
    // 进入解析平台
    geekAisc() {
      window.open(`https://${BASE_URL.WG.PREFIX_DOT}aisc.${BASE_URL.WG.DOMAIN_URL}`, '_blank')
    },
    // 清空缓存
    emptyCache() {
      Storage.clearStorage()
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.yld-framework-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-menu {
    margin-left: 12px;
  }
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    .navbar-download-log {
      margin-left: 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;

      &:hover {
        color: var(--geek-color-primary);
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 16px;
      margin-left: 16px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          color: #333333;
        }
      }
    }

    .language-type {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #333;

      .el-icon--right {
        font-size: 18px;
      }
    }
  }
}
</style>
<style lang="scss">
.yld-dropdown-menu {
  margin: 0 !important;
  padding: 0 !important;

  .el-dropdown-menu__item {
    line-height: 35px;
    margin: 0;

    svg {
      margin-right: 8px;
    }
  }

  .el-dropdown-menu__item--divided:before {
    content: none
  }

  .el-dropdown-menu__item.el-dropdown-menu__item--divided {
    margin: 0 !important;
  }
}
</style>

